<ng-container *ngIf="!question.isReadOnlyRenderDiv()">
  <ng-template [component]="{ name: 'sv-text-area', data: { model: textAreaModel } }"></ng-template>
</ng-container>
<div *ngIf="question.isReadOnlyRenderDiv()">{{ otherValue }}</div>
